import { IconChevronRight } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';

interface DevelopmentManagerTypeOptionProps {
    title: string;
    subtitle: string;
}

const DevelopmentManagerTypeOption: React.FC<DevelopmentManagerTypeOptionProps> = ({
    title,
    subtitle,
}) => (
    <div className="d-flex justify-content-between align-items-center">
        <div>
            <div className="text-dark">{title}</div>
            <div>{subtitle}</div>
        </div>
        <NSIcon icon={IconChevronRight} className="text-dark" />
    </div>
);

export default DevelopmentManagerTypeOption;
